import {TextContentModel} from '../models/text.content-model';
import {ContentResourceInterface} from '../interfaces/content-resource.interface';

export const GetStartedContentResources: ContentResourceInterface & { [id in string]: any } = {


    LastModified: new TextContentModel(
        {'fr': '2024-11-26', 'en': '2024-11-26'},
    ),

    Title: new TextContentModel(
        {'fr': 'Débutez en ligne maintenant', 'en': 'Get started now'},
    ),

    Meta: {
        Description: new TextContentModel(
            {
                'fr': 'Utilisez Optitax dès aujourd\'hui!\n',
                'en': 'Start using Optitax today.\n',
            },
        ),

        Keywords: new TextContentModel(
            {
                'fr': 'optitax, débutez maintenant',
                'en': 'optitax, get started',
            },
        ),
    },

    'get-started.body.access-your-account': new TextContentModel(
        {
            'fr': 'Accédez à votre compte',
            en: 'Access your account',
        },
    ),

    'get-started.body.call-to-action': new TextContentModel(
        {
            'fr': 'Je suis déjà client',
            en: 'Already a customer',
        },
    ),

    'get-started.body.title': new TextContentModel(
        {
            'fr': 'Merci de votre intérêt pour Optitax',
            en: 'Thank you for your interest in Optitax',
        },
    ),

    'get-started.body.subtitle': new TextContentModel(
        {
            'fr': 'Afin de débuter le processus d’activation, vous devez commencer par remplir le formulaire suivant. Vous serez ensuite inviter à vous créer un compte dans Optitax.',
            en: 'To start the activation process, you must first fill out the following form. You will then be invited to create an account in Optitax.',
        },
    ),
};
